import { render, staticRenderFns } from "./LeftWrap1.vue?vue&type=template&id=15643dd4&scoped=true"
import script from "./LeftWrap1.vue?vue&type=script&lang=js"
export * from "./LeftWrap1.vue?vue&type=script&lang=js"
import style0 from "./LeftWrap1.vue?vue&type=style&index=0&id=15643dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15643dd4",
  null
  
)

export default component.exports